import { render, staticRenderFns } from "./FCellSLA.vue?vue&type=template&id=4f6863bd&"
import script from "./FCellSLA.vue?vue&type=script&lang=ts&"
export * from "./FCellSLA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports